import { Component, AfterViewInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { BoxPatternEnum, BoxFormatModel } from '../../../models/box-format.model'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'flowaccount-work-with-us',
  templateUrl: './work-with-us.component.html',
  styleUrls: ['./work-with-us.component.scss'],
})
export class WorkWithUsComponent implements AfterViewInit {
  boxListIntro: BoxFormatModel = {
    boxPattern: BoxPatternEnum.textLeftImageRight,
    boxClassName: 'work-intro',

    boxTopHeading: '',
    boxTopHeading_tablet: '',
    boxTopHeading_mobile: '',
    boxTopSubHeading: '',
    boxTopHeadingDetail: '',

    boxHeading: 'WORK_WITH_US.JOIN_US_SECTION.HEADING',
    boxHeading_tablet: 'WORK_WITH_US.JOIN_US_SECTION.HEADING_TABLET',
    boxHeading_mobile: 'WORK_WITH_US.JOIN_US_SECTION.HEADING_MOBILE',
    boxSubHeading: 'WORK_WITH_US.JOIN_US_SECTION.SUB_HEADING',
    boxHeadingDetail: 'WORK_WITH_US.JOIN_US_SECTION.DETAIL',

    boxImageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section1/image_career-v3.webp',
    boxImage: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section1/image_career-v2.png',
    boxImageType: 'png',
    boxImageAlt: 'join us',

    boxBtnText: 'WORK_WITH_US.JOIN_US_SECTION.LINK',
    boxBtnLinkName: '',
  }

  boxListAboutUs: BoxFormatModel = {
    boxPattern: BoxPatternEnum.textRightImageLeft,
    boxClassName: 'about-us',

    boxTopHeading: '',
    boxTopHeading_tablet: '',
    boxTopHeading_mobile: '',
    boxTopSubHeading: '',
    boxTopHeadingDetail: '',

    boxHeading: 'WORK_WITH_US.ABOUT_US_SECTION.HEADING',
    boxHeading_tablet: 'WORK_WITH_US.ABOUT_US_SECTION.HEADING_TABLET',
    boxHeading_mobile: 'WORK_WITH_US.ABOUT_US_SECTION.HEADING_MOBILE',
    boxSubHeading: '',
    boxHeadingDetail: 'WORK_WITH_US.ABOUT_US_SECTION.DETAIL',
    boxImageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section2/who_are_we.webp',
    boxImage: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section2/who_are_we.jpg',
    boxImageType: 'png',
    boxImageAlt: 'about-us',

    boxBtnText: '',
    boxBtnLinkName: '',
  }

  boxListRecruitment: BoxFormatModel = {
    boxPattern: BoxPatternEnum.textLeftImageRight,
    boxClassName: 'work-recruitment',

    boxTopHeading: '',
    boxTopHeading_tablet: '',
    boxTopHeading_mobile: '',
    boxTopSubHeading: '',
    boxTopHeadingDetail: '',

    boxHeading: 'WORK_WITH_US.RECRUITMENT_SECTION.HEADING',
    boxHeading_tablet: 'WORK_WITH_US.RECRUITMENT_SECTION.HEADING_TABLET',
    boxHeading_mobile: 'WORK_WITH_US.RECRUITMENT_SECTION.HEADING_MOBILE',
    boxSubHeading: '',
    boxHeadingDetail: '',

    boxImageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section1/image_career-v3.webp',
    boxImage: 'https://flowaccountcdn.com/new_landing/image/work-with-us/section1/image_career-v2.png',
    boxImageType: 'png',
    boxImageAlt: 'join us',

    boxBtnText: 'WORK_WITH_US.RECRUITMENT_SECTION.BTN',
    boxBtnLinkName: 'https://flowaccount.breezy.hr/',
  }

  blogTechList = [
    {
      blogTitle: 'Internals of DynamoDB',
      blogContent:
        'DynamoDB คือ Database system ตัวหนึ่งที่เกิดมาในรูปแบบของ NoSQL หากเราต้องทำงานวนเวียนอยู่กับระบบ Cloud การรู้จัก DynamoDB อาจช่วยให้ Developer มีตัวเลือกพัฒนาระบบมากขึ้น',
      blogLink: 'https://medium.com/flowaccount-tech/internals-of-dynamodb-c324e4fbb12c',
      blogAlt: 'Internals of DynamoDB',
      blogImage: 'https://flowaccountcdn.com/new_landing/image/work-with-us/techBlog/dynamo_db.jpg',
      blogImageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/techBlog/dynamo_db.webp',
    },
    {
      blogTitle: 'Angular with NodeJs and Single Signon (Authorization Code Flow)',
      blogContent:
        'In this article, we will talk about how to startup a universal angular app that integrates with a Single Signon Server using the authorization code flow.',
      blogLink:
        'https://medium.com/flowaccount-tech/angular-with-nodejs-and-single-signon-authorization-code-flow-b6ce72b69e2',
      blogAlt: 'Angular with NodeJs and Single Signon',
      blogImage: 'https://flowaccountcdn.com/new_landing/image/work-with-us/techBlog/angular_signon.jpg',
      blogImageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/techBlog/angular_signon.webp',
    },
    {
      blogTitle: 'การใช้ Jenkins ในการพัฒนา DevOps',
      blogContent:
        'บางบริษัทกำหนดให้ DevOps คือแผนกที่คอยจัดการ Infrastructure, Operations, Code Pipeline และอื่นๆ ที่ Developer ไม่ได้ทำกัน แต่ในบทความนี้จะเล่าถึงการนำไปใช้พัฒนาวัฒนธรรมองค์กร',
      blogLink: 'https://medium.com/flowaccount-tech/การใช้-jenkins-ในการพัฒนา-devops-2cf4efcb50d5',
      blogAlt: 'การใช้ Jenkins ในการพัฒนา DevOps',
      blogImage: 'https://flowaccountcdn.com/new_landing/image/work-with-us/techBlog/devop_jenkin.jpg',
      blogImageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/techBlog/devop_jenkin.webp',
    },
  ]

  boxListHrAccountant: BoxFormatModel = {
    boxPattern: BoxPatternEnum.textRightImageLeft,
    boxClassName: 'hr-accountant',

    boxTopHeading: '',
    boxTopHeading_tablet: '',
    boxTopHeading_mobile: '',
    boxTopSubHeading: '',
    boxTopHeadingDetail: '',

    boxHeading: 'WORK_WITH_US.HR_ACCOUNTANT.HEADING',
    boxHeading_tablet: 'WORK_WITH_US.HR_ACCOUNTANT.HEADING_TABLET',
    boxHeading_mobile: 'WORK_WITH_US.HR_ACCOUNTANT.HEADING_MOBILE',
    boxSubHeading: '',
    boxHeadingDetail: 'WORK_WITH_US.HR_ACCOUNTANT.DETAIL',

    boxImageWebP: 'https://flowaccountcdn.com/new_landing/image/work-with-us/accounting/accountant_job_v1.webp',
    boxImage: 'https://flowaccountcdn.com/new_landing/image/work-with-us/accounting/accountant_job_v1.png',
    boxImageType: 'png',
    boxImageAlt: 'join us',

    boxBtnText: 'WORK_WITH_US.HR_ACCOUNTANT.BTN',
    boxBtnLinkName: '',
    boxBtnRouteNamePath: 'jobs',
    boxBtnRouteNameSubPath: 'accountant-in-tech',
  }

  constructor(private seoService: SEOService, public translate: TranslateService, private titleService: Title) {
    this.setMeta()
    this.translate.onLangChange.subscribe((event) => {
      this.setMeta()
    })
  }

  ngAfterViewInit(): void {
    this.checkQrCookieAndRedirect()
  }

  setMeta() {
    this.titleService.setTitle(this.translate.instant('metatitle-Jobs'))
    this.seoService.createMetaTag(this.translate.instant('metatitle-Jobs'), this.translate.instant('metaDescription'))
    this.seoService.createOg(
      'https://flowaccountcdn.com/images/Thumnail_FlowPayroll_FlowAccount.png',
      this.translate.instant('metatitle-Jobs'),
      this.translate.instant('metaDescription'),
    )
  }

  private checkQrCookieAndRedirect(): void {
    const cookies = document.cookie
    const shouldRedirect = cookies.includes('redirectToSalesPartnerJobForm=true')

    if (!shouldRedirect) return

    window['dataLayer'] = window['dataLayer'] || []
    window['dataLayer'].push({
      event: 'scan-apply-sales-partner',
    })

    document.cookie = 'redirectToSalesPartnerJobForm=; max-age=0; path=/'

    const forms = 'https://docs.google.com/forms/d/e/1FAIpQLSejqSOJdfrtOXYa8MVY5vD2EA1e5ZAGhEMSlko6cID-n2fvNw/viewform'

    setTimeout(() => {
      window.location.href = forms
    }, 500)
  }
}
